import React from "react";
import styled from "styled-components/macro";
import { formatBgn, formatEuro } from "features/utils";
import { SHOW_BGN_PRICES } from "config";

interface DualPriceProps {
  bgn: number | string;
  eur?: number | string | null;
  className?: string;
  showBgn?: boolean;
}

export const EuroPrice: React.FC<DualPriceProps> = ({ bgn, eur, className }) => (
  <span className={className}>{formatEuro(bgn, eur)} €</span>
);

const DualPrice: React.FC<DualPriceProps> = ({
  bgn,
  eur,
  className,
  showBgn,
}) => {
  const shouldShowBgn = showBgn ?? SHOW_BGN_PRICES;

  return (
    <PricePair className={className}>
      <span className="price-eur">{formatEuro(bgn, eur)} €</span>
      {shouldShowBgn && (
        <span className="price-bgn">{formatBgn(bgn)} лв.</span>
      )}
    </PricePair>
  );
};

const PricePair = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;

  .price-eur {
    font-size: 0.85em;
    font-weight: 700;
  }

  .price-bgn {
    font-size: 0.72em;
    font-weight: 400;
    opacity: 0.72;
  }
`;

export default DualPrice;
